export default "__VITE_ASSET__BDBA83cA__"